/* eslint-disable react/state-in-constructor */
import './App.css';
import { API } from './api';
import { DimaContext } from './DimaContext';
import { Layout } from 'antd';
import { BrowserRouter as Router } from 'react-router-dom';
import { fetchUserPreferences } from './utils/util';
import HeaderMenu from './components/layout/headerMenu';
import React, { Component } from 'react';
import Routes from './routes';
import SiderMenu from './components/layout/siderMenu';
import StagingAlert from './components/layout/stagingAlert';

const { Header, Content, Sider } = Layout;

class App extends Component {
  // shared, global state
  constructor(props) {
    super(props);
    this.state = {
      collapsed: localStorage.getItem('siderCollapsed') || true,
      client: JSON.parse(localStorage.getItem('selectedClient')) || null,
      setClient: this.setClient,
      current: null,
      unsavedGroovyChanges: false,
      setUnsavedGroovyChanges: this.setUnsavedGroovyChanges,
      handleClick: this.handleClick,
      userData: {
        userId: localStorage.getItem('user_id') || null,
        permissions: [],
        preferences: [],
      },
      setUserData: this.setUserData,
    };
  }

  async componentDidMount() {
    const { userId } = this.state.userData;
    let newUserData = {};

    if (process.env.REACT_APP_FEATURE_PERMISSIONS_V2 && userId) {
      const response = await API.get(`/user/${userId}/permissions`);

      if (response.status === 200) {
        newUserData = { ...response.data };
        newUserData.authenticated = true;
      }
    }

    if (userId) {
      const userPreferences = await fetchUserPreferences();
      newUserData.preferences = userPreferences;
    }

    newUserData.loaded = true;
    this.setUserData(newUserData);
  }

  setUserData = (update = {}) => {
    this.setState(prevState => {
      const updatedUserData = { ...prevState.userData, ...update };
      return { ...prevState, userData: updatedUserData };
    });
  };

  setClient = client => {
    localStorage.setItem('selectedClient', JSON.stringify(client));
    this.setState({ client });
  };

  clearUnsavedGroovyChanges = () => {
    this.setState({ unsavedGroovyChanges: false });
  };

  setUnsavedGroovyChanges = unsavedGroovyChanges => this.setState({ unsavedGroovyChanges });

  handleUnsavedGroovyChanges = unsavedGroovyChanges => this.setState({ unsavedGroovyChanges });

  handleCollapseToggle = collapsed => {
    localStorage.setItem('siderCollapsed', collapsed);
    this.setState({ collapsed });
  };

  handleClick = () => {
    // Only toggle if sider is open
    if (!this.state.collapsed) {
      this.handleCollapseToggle(!this.state.collapsed);
    }

    this.clearUnsavedGroovyChanges();
  };

  handleSidebarClick = () => {
    this.forceUpdate();
  };

  render() {
    const isMappingView = !!window.location.pathname.includes('map/');
    const contentStyle =
      this.state.client != null
        ? {
            paddingLeft: 110,
            paddingRight: 50,
            paddingBottom: 50,
            paddingTop: 20,
          }
        : { margin: '50px 50px' };
    const siderStyle = {
      borderTop: '1px solid rgba(215, 219, 221, 0.37)',
      minHeight: '100%',
      position: 'fixed',
      zIndex: 99,
    };
    const headerStyle = { position: 'sticky', top: 0, zIndex: 99, width: '100%' };
    const showStagingAlert = process.env.REACT_APP_HOST.includes('1uphealthdatadev');

    return (
      // DimaContext to be used sparingly, can potentially lead to performance issues due to excessive re-rendering
      // TODO: Refactor context, and verify what should be stored in it and what should remain in state.
      <DimaContext.Provider value={this.state}>
        <Router>
          <Header style={headerStyle} onClick={this.handleSidebarClick}>
            <HeaderMenu isMappingView={isMappingView} />
          </Header>
          <Layout style={{ background: 'white' }}>
            {isMappingView && (
              <Sider
                collapsible
                collapsed={this.state.collapsed}
                style={siderStyle}
                onCollapse={collapsed => this.handleCollapseToggle(collapsed)}
                width={200}
              >
                <SiderMenu />
              </Sider>
            )}
            <Content style={contentStyle}>
              <Routes handleUnsavedGroovyChanges={this.handleUnsavedGroovyChanges} />
              {showStagingAlert && <StagingAlert />}
            </Content>
          </Layout>
        </Router>
      </DimaContext.Provider>
    );
  }
}

export default App;
